import { createSelector } from 'reselect'

export const getIsAuthorized = createSelector(
  (state) => Boolean(state && state.user && state.user.auth && state.user.auth.isAuthorized),
  (isAuthorized) => isAuthorized
)
